import { render, staticRenderFns } from "./customerUpdate.vue?vue&type=template&id=aec21894&"
import script from "./customerUpdate.vue?vue&type=script&lang=js&"
export * from "./customerUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports